import React from 'react';
import Header from '../component/header/Header';
import Footer from '../component/footer/Footer';
import ContactFloatingButtons from '../component/ContactFloatingButtons';

const Layout = ({ children }) => {
    return (
        <div style={{ backgroundColor: '#fff' }}>
            <Header />
            <main>
                {children}
            </main>
            <ContactFloatingButtons />
            <Footer />
        </div>
    );
};

export default Layout;
